export const gstReducerSelector = state => state.gstReducer;
